import React from 'react';
import { zoneTableStyles as styles } from './chat.tailwind'
import { useSelector } from 'react-redux';

const ZoneActivityTable = () => {
  const { gameZoneDetails, gameZoneDetailsLoading } = useSelector((state) => state.liveGame);

  if(gameZoneDetailsLoading) {
    return (
      <div className={`${styles.tableContainer}`}>
        <Headers />

        {Array.from({ length: 2 }).map((_, index) => (
          <div key={index} className={`${styles.activity_skeleton_row} h-[30px] animate-pulse`} />
        ))}
      </div>
    )
  }
  
  if(gameZoneDetails?.length === 0) {
    return (
      <div className={styles.tableContainer}>
        <Headers />

        <p className='text-white text-xs screen-500:text-sm text-center py-4'>No actions recorded till now.</p>
      </div>
    )
  }

  return (
    <div className={styles.tableContainer}>
        <Headers />        

        {gameZoneDetails?.map((action, key) => (
            <ActivityRow key={key} action={action} />
          )
        )}
    </div>
  )
}

export default ZoneActivityTable;

const Headers = () => {
  return (
    <div className={styles.table_headers}>
        <span className={`${styles.header_text} flex-[0.7]`}>Actions</span>
        <span className={`${styles.header_text} flex-[0.3] flex items-center justify-center`}>No. of Times</span>
    </div>
  )
}

const ActivityRow = ({ action }) => {
    return (
        <div className={styles.activity_row}>
            <span className={`${styles.activity_row_text} flex-[0.7]`}>{action?.actionName}</span>

            <span className={`${styles.activity_row_text} flex-[0.3] flex items-center justify-center`}>{action?.count}</span>
        </div>
    );
}